export default __webpack_public_path__ + "static/media/banner2.3250b30f.png";